import React from "react";

import {
  CardBody,
  Row, 

} from "shards-react";
import TopicGraph from './TopicGraph';
import Influence from './Influence';
import TopInfluencers from './TopInfluencers';
import InfluencersByScore from './InfluencersByScore';
import Botness from './Botness';
import TablesForTopInfluencer from './TablesForTopInfluencer';
// import SocialNetworkAll from './SocialNetworkAll'

export default class HiddenBox extends React.Component {
  constructor(props) {
    super(props);
    console.log(props.topicId);
    
}
  render() {
    return (
      // <div> I was hidden </div>
      <CardBody className="px-2">  
        <h6 class='text-white'>Influence Score = Total number of retweets + replies + text quoted + favorites</h6>
        <div className="py-2" ><Influence topicId={this.props.topicId} /></div>
        <div className="py-2"><InfluencersByScore topicId={this.props.topicId} /></div>
        <div className="py-2"><TopInfluencers topicId={this.props.topicId} /></div>
        <div className="py-2"><Botness topicId={this.props.topicId} /></div>
        <div className="py-2" ><TablesForTopInfluencer topicId={this.props.topicId} /></div>
       

      </CardBody>
     
      );
  }
}
